import React, { useState } from "react";
import { hashHistory } from "react-router";
import Grid from "@material-ui/core/Grid";
import TableInc from "../../../../shared-ui/TableInc";
import ButtonInc from "../../../../shared-ui/ButtonInc";
import { formatDateLocale } from "../../../../lib/utils.es6";
import { TablePagination } from "@mui/material";

const CancellationTable = (props) => {
  const { policies, loader, page, size, total, onPageChange, status, onApprove, onReject } = props;
  const [rowsPerPage, setRowsPerPage] = useState(size || 10);

  const handlePageChange = (event, newPage) => {
    onPageChange({
      page: newPage + 1,
      size: rowsPerPage,
      status,
    });
  };

  const handleRowsPerPageChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setRowsPerPage(newSize);
    onPageChange({
      page: 1,
      size: newSize,
      status,
    });
  };

  const tempArr = (policies || [])
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .map((item) => ({
      ...item,
      created_at_display: formatDateLocale(item.created_at) || "N/A",
      policy_number_display: item.policy_number || "N/A",
      customer_name: item.additional_details && item.additional_details.principal_full_names
        ? item.additional_details.principal_full_names
        : "N/A",
      cancellation_status: item.cancellation_status || item.status || "N/A",
      cancellation_reason: item.cancellation_reason || item.reason || "N/A",
    }));

  const columns = [
    {
      title: "Policy Number",
      field: "policy_number_display",
      render: (rowData) => rowData.policy_number_display,
    },
    {
      title: "Status",
      field: "cancellation_status",
    },
    {
      title: "Reason",
      field: "cancellation_reason",
    },
    {
      title: "Created At",
      field: "created_at_display",
    },
    {
      title: "Actions",
      field: "actions",
      render: (rowData) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <ButtonInc
            variant="contained"
            onClick={() =>
              hashHistory.push(
                `admin/policy-processing/${rowData.policy_number}`
              )
            }
          >
            View Policy
          </ButtonInc>
          {status === "Raised" && onApprove && onReject && (
            <>
              <ButtonInc
                variant="contained"
                style={{ background: "#fba92c", color: "#fff" }}
                onClick={() => onApprove(rowData)}
              >
                Approve
              </ButtonInc>
              <ButtonInc
                variant="contained"
                style={{ background: "#f44336", color: "#fff" }}
                onClick={() => onReject(rowData)}
              >
                Reject
              </ButtonInc>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} sm={12}>
        <TableInc
          columns={columns}
          data={tempArr}
          options={{
            pageSize: size,
            page: (page || 1) - 1,
            totalCount: total,
            paging: false,
            showTitle: false,
            search: true,
          }}
          emptyMessage={loader ? "Loading..." : "No cancellation requests found"}
        />

        <TablePagination
          component="div"
          count={total || 0}
          page={(page || 1) - 1}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </Grid>
    </Grid>
  );
};

export default CancellationTable;
